import React, {useEffect, useState} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from "react-router-dom"
import Snackbar from '@mui/material/Snackbar'
import {injectIntl} from 'react-intl'
import Mobile from './Mobile'
import Desktop from './Desktop'
import {isMobile} from 'utils/utils'
import {fetchLogin, fetchAutologin, fetchRegistration, fetchInstances} from 'modules/login/actions'

const Login = ({type, intl}) => {
	let navigate = useNavigate()
	const mobile = isMobile()
	const dispatch = useDispatch()
	const instances = useSelector((state) => state.login.list)
	const defaultInstance = useSelector((state) => state.login.instance)
	const isAuthorized = useSelector((state) => state.login.isAuthorized)

	const [values, setValues] = useState({
			username: '',
            newusername: '',
            password: '',
            newpassword: '',
            instance: '',
            passwordRepeat: '',
            isValid: true,
            showPassword: false,
            showPasswordRepeat: false
	})

	useEffect(() => {
		dispatch(fetchAutologin())
        dispatch(fetchInstances())
	}, [])

	useEffect(() => {
		if (isAuthorized) {
			navigate('/', {replace: true})
		}
	}, [isAuthorized])

    const handleLogin = (e) => {
        e.preventDefault()
        if (values.username && values.password) {
            dispatch(fetchLogin({
                username: values.username,
                password: values.password,
                instance: values.instance || defaultInstance
            }))
        } else {
            setValues({ ...values, isValid: false })
        }
    }

    const handleRegistration = (e) => {
        e.preventDefault()
        if (values.newusername && values.newpassword === values.passwordRepeat) {
            dispatch(fetchRegistration({
                newusername: values.newusername,
                newpassword: values.newpassword,
                instance: values.instance || defaultInstance
            }))
        } else {
            setValues({ ...values, isValid: false })
        }
    }

    const handleClose = (e, reason) => {
        if (reason === 'clickaway') {
            return
        }

        setValues({ ...values, isValid: true })
    }

    const handleChange = (e) => {
		setValues({ ...values, [e.target.name]: e.target.value })
	}

	const handleClickPassword = (name) => {
		setValues({
		  ...values,
		  [name]: !values[name]
		})
	}

	return (
		<React.Fragment>
			{!mobile ?
				<Desktop
					type={type}
					password={values.showPassword}
					repeat={values.showPasswordRepeat}
					handleClickPassword={handleClickPassword}
					instance={defaultInstance}
					instances={instances}
					handleLogin={handleLogin}
					handleChange={handleChange}
					handleRegistration={handleRegistration}
				/>
				:
				<Mobile
					type={type}
					password={values.showPassword}
					repeat={values.showPasswordRepeat}
					handleClickPassword={handleClickPassword}
					instance={defaultInstance}
					instances={instances}
					handleLogin={handleLogin}
					handleChange={handleChange}
					handleRegistration={handleRegistration}
				/>
			}
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				onClose={handleClose}
				open={!values.isValid}
				autoHideDuration={4000}
				message={intl.formatMessage({id: "login.invalid"})}
			/>
		</React.Fragment>
	)
}

export default injectIntl(Login)
